var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashStack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 4,
    fill: "#D4EEF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 36H37M34.1771 20C33.7619 20.3665 33.5 20.9027 33.5 21.5C33.5 22.6046 34.3954 23.5 35.5 23.5C35.6726 23.5 35.8402 23.4781 36 23.437M22 32C22.781 31.219 22.781 29.781 22 29C21.219 28.219 19.781 28.219 19 29M22 20C22.781 20.781 22.781 22.219 22 23C21.219 23.781 19.781 23.781 19 23M34 32C33.219 31.219 33.219 29.781 34 29C34.781 28.219 36.219 28.219 37 29M22.2 32H33.8C34.9201 32 35.4802 32 35.908 31.782C36.2843 31.5903 36.5903 31.2843 36.782 30.908C37 30.4802 37 29.9201 37 28.8V23.2C37 22.0799 37 21.5198 36.782 21.092C36.5903 20.7157 36.2843 20.4097 35.908 20.218C35.4802 20 34.9201 20 33.8 20H22.2C21.0799 20 20.5198 20 20.092 20.218C19.7157 20.4097 19.4097 20.7157 19.218 21.092C19 21.5198 19 22.0799 19 23.2V28.8C19 29.9201 19 30.4802 19.218 30.908C19.4097 31.2843 19.7157 31.5903 20.092 31.782C20.5198 32 21.0799 32 22.2 32ZM30 26C30 27.1046 29.1046 28 28 28C26.8954 28 26 27.1046 26 26C26 24.8954 26.8954 24 28 24C29.1046 24 30 24.8954 30 26Z",
    stroke: "#19292F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashStack);
export default __webpack_public_path__ + "static/media/cash-stack.ddaea661fb0f4de40ab82d6d699ce62f.svg";
export { ForwardRef as ReactComponent };